// Central registry of selectable profile avatars.
//
// Each user stores only the avatar `id` (in their Firestore "users" doc, field
// `avatarId`); the actual image is a bundled asset resolved here at render time.
// To add or remove an option, edit the AVATARS array below — give every entry a
// unique `id` (never reuse/rename an existing id, or users pointing at it will
// fall back to the default) and a bundled image `src`. The `label` is used for
// the image alt text / tooltip in the picker.
//
// `id` and `label` follow the source filename number (avatar_05.png -> id
// "avatar-05", "Avatar 5"), so the numbering mirrors the files in img/profiles.

const AVATARS = [
  { id: "avatar-01", label: "Avatar 1", src: require("assets/img/profiles/avatar_01.png") },
  { id: "avatar-02", label: "Avatar 2", src: require("assets/img/profiles/avatar_02.png") },
  { id: "avatar-05", label: "Avatar 5", src: require("assets/img/profiles/avatar_05.png") },
  { id: "avatar-06", label: "Avatar 6", src: require("assets/img/profiles/avatar_06.png") },
  { id: "avatar-07", label: "Avatar 7", src: require("assets/img/profiles/avatar_07.png") },
  { id: "avatar-08", label: "Avatar 8", src: require("assets/img/profiles/avatar_08.png") },
  { id: "avatar-09", label: "Avatar 9", src: require("assets/img/profiles/avatar_09.png") },
];

// The avatar shown when a user has not picked one yet.
export const DEFAULT_AVATAR_ID = "avatar-01";

// The full list of options, for rendering a picker.
export const getAvatars = () => AVATARS;

// Resolve a stored avatarId to its bundled image src, falling back to the default.
export const resolveAvatar = (avatarId) => {
  const match = AVATARS.find((avatar) => avatar.id === avatarId);
  const fallback = AVATARS.find((avatar) => avatar.id === DEFAULT_AVATAR_ID);
  return (match || fallback).src;
};
